<template>
    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> CLIENTES DE
            PACPON NESTE CTO
        </div>
        <div class="panel-body" v-if="ctos.length">
            <table id="mytable" class="table table-bordred table-striped">
                <thead>
                    <tr>
                        <th>NOME</th>
                        <th style="text-align: center;width: 100px">PLANO</th>
                        <th style="text-align: center;width: 100px">STATUS</th>
                        <th style="text-align: center;width: 100px">AÇÕES</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="r in ctos" v-bind:key="r._id">
                        <td>{{ r.cliente.nome }}</td>
                        <td style="text-align: center; color: GREEN">
                            {{ r.radio.download / 1024 }} MB
                        </td>
                        <td
                            style="text-align: center; color: RED"
                            v-if="!r.sessao_online.online"
                        >
                            OFFLINE
                        </td>
                        <td style="text-align: center; color: GREEN" v-else>
                            ONLINE
                        </td>

                        <td style="text-align: center">
                            <a
                                :href="'#/contrato/add/' + r._id"
                                class="btn btn-primary btn-xs"
                            >
                                ABRIR
                                <i
                                    class="fa fa-angle-double-right"
                                    aria-hidden="true"
                                ></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="panel-body" v-else>
            <h3 style="padding-left: 20px">NENHUM CLIENTE PACPON NESTE CTO</h3>
        </div>
    </div>
</template>

<script>
import { Contratos } from "../../class/index";
export default {
    name: "ListClientesNoPacpon",
    props: {
        _id: {
            default: null
        }
    },
    data() {
        return {
            ctos: []
        };
    },
    beforeMount() {
        Contratos.byCTO(this._id)
            .then(rows => (this.ctos = rows))
            .catch(err => console.log(err));
    }
};
</script>

<style scoped></style>
